// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2020-12-14 19:44:07 +0100 (Mon, 14 Dec 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 115587 $
//  Purpose   : example part
/*
<!-- adding a new view (/uix/theview/123) to server/config/templateconfig.xml -->
<class name="uix" acl="g:admin">
  <tab name="theview" cfg="templating.feature.on">
      <part type="ExamplePart" acl="g:admin" style="flex:1" >
        <filter type="getExampleData"/>
      </part>
  </tab>
*/
// =============================================================================

// ---Third-party imports
import React, {Component} from 'react'
import {Segment, Grid, Icon} from 'semantic-ui-react'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {Part, funcPart} from 'uix/parts'
import log from 'uix/logging'
import {keys} from 'ldash'
import {useSelector, useState} from 'uix/hooks'
// ---Local imports
import {sendSignal} from './actions'

// ---Exports
// class based components use static members to describe environment access
// functional component can give an (optional) part specification dict with the same members
const spec = {storeMap: 'config.ddata'}
export const FunctionalPart = funcPart(spec, ({dname, ddata, ...props}) => {
  let dconfig = useSelector(Sel.dconfig)
  let [clicked, setClicked] = useState(false)
  log.warn('rendering the functional example %o', props)
  log.info('request domain is a default part prop: %o', dname)
  log.info('store access via redux connect HOC: %o', ddata)
  log.info('store access via redux selector hook: %o', dconfig)
  return (
    <Segment onClick={() => setClicked(true)}>
      Welcome to {keys(props.domains.data).join(', ')}
      <br />
      clicked: {String(clicked)}
    </Segment>
  )
})

export class ExamplePart extends Part {
  /* document me
   */

  static defaultProps = {
    // ... some static defaults
    gender: 'female',
  }

  // optional prop validation
  static propTypes = {
    gender: PropTypes.oneOf(['male', 'female']),
  }

  // read some data from store, access as this.props.request
  // can also be a simple list or a function (see connect.js)
  static storeMap = {
    // already in default mapping, see parts/part.js
    request: 'meta.request',
  }

  // write data to store or feed into local sagas
  // use as this.props.go({classname: 'admin', tabname: 'timeline'})
  static actionMap = {
    // already in default action mapping
    go: Actions.go,
    // local action
    sendSignal,
  }

  // persist stuff in localStorage
  // values are injected as this.props.ui
  // and the write-action as this.props.setUI
  static uiDefaults = {
    __version__: 1, // increase, if you change data schema (0 is default)
    switchMe: false, // this.props.ui.switchMe
  }

  // lazy load some svg based graphic chunks
  // these will be injected as this.props.Graphics
  static getGraphics = ['types']

  // set some css styles on wrapping div build by _render
  static partStyle = {
    display: 'flex',
    flexDirection: 'column',
    height: '95%',
  }

  // alternativly default can also be given as class prop
  // state = {some: 'value'}
  constructor(props) {
    super(props)
    // some inital default component state
    this.state = {some: 'value'}
  }

  _render() {
    /* called by render() and wrapped in default part div
     */
    const {ui, setUI} = this.props
    // see debug console
    log.warn('rendering the example %o', this.props)

    // show this.props
    vl.pprint(this.props)

    // render me
    return <div onClick={event => this.props.sendSignal({hello: 'world'})}>hello world</div>
  }
}
